import { api } from './client';

export interface Features {
	kubehound: boolean;
}

export function getFeatures(): Promise<Features> {
	return api.get<Features>('/v1/features');
}
